/** @jsxImportSource @emotion/react */

interface AddSectionIconProps {
  size?: number
  color?: string
}

const AddSectionIcon = ({
  size = 16,
  color = '#F2B400',
}: AddSectionIconProps) => {
  return (
    <svg
      xmlns='http://www.w3.org/2000/svg'
      width={size}
      height={size + 1}
      viewBox='0 0 16 17'
      fill='none'
    >
      <path
        d='M12.6666 9.16668H8.66665V13.1667H7.33331V9.16668H3.33331V7.83334H7.33331V3.83334H8.66665V7.83334H12.6666V9.16668Z'
        fill={color}
      />
    </svg>
  )
}

export default AddSectionIcon
